import { Note, Ticket } from "callable-data-objects";
import CallableTextArea from "Components/Shared/CallableTextArea";
import { Field, Formik } from "formik";
import useCheckRole from "Hooks/APICheckRole";
import React, { Fragment } from "react";
import { Button, Divider, Feed, Form } from "semantic-ui-react";
import { string, object } from "yup";

const NotePostSchema = object().shape({
  note: string().required(),
});

type TicketNoteProps = {
  ticket: Ticket;
  addNote: Function;
};

const TicketNote = ({ ticket, addNote }: TicketNoteProps) => {
  const { hasRole, roles } = useCheckRole();
  return (
    <Fragment>
      {hasRole(roles.ticket.roles.note) && (
        <Formik
          validationSchema={NotePostSchema}
          initialValues={{ note: "" }}
          onSubmit={(values, actions) => {
            console.log(values);
            addNote(values);
            actions.resetForm();
          }}
        >
          {(props) => (
            <Form onSubmit={props.handleSubmit}>
              <Field
                name='note'
                placeholder='Enter Note'
                component={CallableTextArea}
              />

              <Button secondary type='submit' size='mini'>
                Add Note
              </Button>
            </Form>
          )}
        </Formik>
      )}
      <br />
      <Divider />
      <Feed>
        {ticket.notes &&
          ticket.notes.map((note: Note) => (
            <Feed.Event>
              <Feed.Content>
                <Feed.Summary>
                  <Feed.User>{note.username}</Feed.User>
                  <Feed.Date>{note.created}</Feed.Date>
                </Feed.Summary>
                <Feed.Extra text>{note.note}</Feed.Extra>
              </Feed.Content>
            </Feed.Event>
          ))}
      </Feed>
    </Fragment>
  );
};

export default TicketNote;
